import {
  createCategory as apiCreateCategory,
  deleteCategory as apiDeleteCategory,
  getAdminCategories,
  getAdminCategory,
  getPublicCategories,
  getPublicCategory,
  updateCategory as apiUpdateCategory,
} from '../lib/api';
import type { Category, CategoryInput, CategoryUpdateInput } from '../types/category';
import { categoryToHomeItem, type HomeCategoryItem } from '../types/homeCategory';

export async function getCategories(): Promise<Category[]> {
  return getAdminCategories();
}

/** Active categories for the storefront navigation. */
export async function getHomeCategories(): Promise<HomeCategoryItem[]> {
  const categories = await getPublicCategories();
  return categories.map(categoryToHomeItem);
}

export { getPublicCategories, getPublicCategory, getAdminCategory };

export async function createCategory(input: CategoryInput): Promise<Category> {
  return apiCreateCategory(input);
}

export async function updateCategory(id: number, input: CategoryUpdateInput): Promise<Category> {
  return apiUpdateCategory(id, input);
}

export async function deleteCategory(id: number): Promise<void> {
  return apiDeleteCategory(id);
}
